export default __webpack_public_path__ + "static/media/misc-pantry1-480w.54e4f8af.webp";